import { Routes, Route, useLocation } from 'react-router-dom';
import { Key, Gift, Sparkles, Receipt, ArrowLeft, Shield, User } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
// Import settings components
import ApiKeys from './settings/ApiKeys';
import Subscription from './settings/Subscription';
import GiftCard from './settings/GiftCard';
import BillingHistory from './settings/BillingHistory';
import Account from './settings/Account';
import { WorkspaceShell, type WorkspaceNavItem } from '../components/layout';

export default function Settings() {
  const location = useLocation();
  const { t } = useTranslation(['settings', 'common']);
  const { user } = useAuth();

  const tabs = [
    { id: 'account', label: t('nav.account'), description: t('nav.account_desc'), icon: User, path: '/console/account' },
    { id: 'api', label: t('nav.api_keys'), description: t('nav.api_keys_desc'), icon: Key, path: '/console/api' },
    { id: 'subscription', label: t('nav.subscription'), description: t('nav.subscription_desc'), icon: Sparkles, path: '/console' },
    { id: 'billing-history', label: t('nav.billing_history'), description: t('nav.billing_desc'), icon: Receipt, path: '/console/billing-history' },
    { id: 'giftcard', label: t('nav.gift_card'), description: t('nav.gift_card_desc'), icon: Gift, path: '/console/giftcard' },
  ];

  const navItems: WorkspaceNavItem[] = tabs.map(tab => ({
    label: tab.label,
    path: tab.path,
    icon: tab.icon,
    active: location.pathname === tab.path,
  }));

  const utilityItems: WorkspaceNavItem[] = [
    ...(user?.role === 'admin' ? [{ label: t('common:admin_dashboard'), path: '/dashboard', icon: Shield }] : []),
    { label: t('nav.back_to_home'), path: '/', icon: ArrowLeft },
  ];

  return (
    <WorkspaceShell
      title={t('nav.title')}
      subtitle={t('nav.subtitle')}
      sectionLabel={t('common:topbar.product_llm')}
      navItems={navItems}
      utilityItems={utilityItems}
      hideHeaderText
      contentClassName="flex flex-col px-4 py-5 sm:px-6"
    >
      <div className="flex w-full flex-1 flex-col">
        <Routes>
          <Route path="/" element={<Subscription />} />
          <Route path="/account" element={<Account />} />
          <Route path="/billing-history" element={<BillingHistory />} />
          <Route path="/giftcard" element={<GiftCard />} />
          <Route path="/api" element={<ApiKeys />} />
        </Routes>
      </div>
    </WorkspaceShell>
  );
}
